import React from "react";
import {observer} from "mobx-react-lite";
import {stores} from "../stores";
import {faCheck, faExclamationCircle} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export const DeviceInfo = observer(() => {

    return (
        <div className="row">
            {stores.midi.deviceFound && <div className="green">
                <FontAwesomeIcon icon={faCheck} /> DMC.micro v{stores.memory.getDecodedVersion()}, SN {stores.memory.getSerial()}
            </div>}
            {!stores.midi.deviceFound && <div className="red"><FontAwesomeIcon icon={faExclamationCircle} /> DMC.micro not found</div>}
        </div>
    );

});
